import { ListChecks, Users } from "lucide-react";

import { cn } from "@/lib/utils";

/**
 * Tab strip at the top of the expanded right-hand conversation panel: Participants ↔
 * Tasks live side by side instead of replacing each other invisibly. `trailing`
 * hosts the hide-panel control so both panels keep one consistent header row.
 */
export function RightPanelTabs({ active, onChange, tasksBadge = 0, trailing }) {
  const tabs = [
    { id: "participants", label: "Participants", icon: Users },
    { id: "tasks", label: "Tasks", icon: ListChecks },
  ];
  return (
    <div
      role="tablist"
      aria-label="Right panel view"
      className="flex shrink-0 items-center gap-0.5 border-b border-border bg-background px-1.5 pt-1"
    >
      {tabs.map((tab) => {
        const Icon = tab.icon;
        const isActive = active === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => {
              if (!isActive) onChange?.(tab.id);
            }}
            className={cn(
              "inline-flex items-center gap-1.5 rounded-t-md border-b-2 px-2.5 py-1.5 text-[11px] leading-none transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
              isActive
                ? "border-indigo-600 font-semibold text-foreground dark:border-indigo-400"
                : "border-transparent font-medium text-muted-foreground hover:text-foreground",
            )}
          >
            <Icon
              className={cn(
                "h-3.5 w-3.5 shrink-0",
                isActive ? "text-indigo-600 dark:text-indigo-400" : "",
              )}
              strokeWidth={2.25}
              aria-hidden
            />
            {tab.label}
            {tab.id === "tasks" && tasksBadge > 0 ? (
              <span className="inline-flex h-3.5 min-w-3.5 items-center justify-center rounded-full bg-indigo-600 px-1 text-[9px] font-bold leading-none text-white dark:bg-indigo-500">
                {tasksBadge}
              </span>
            ) : null}
          </button>
        );
      })}
      {trailing ? <span className="ml-auto flex items-center pb-0.5">{trailing}</span> : null}
    </div>
  );
}
